// default environment: development

export const environment = {
  isDevelopment: true,
  wsConnection: (systemName: string) => `wss://api.${systemName}.dev.assortment.leafio.app/cable?token=`,
  apiUrl: (systemName: string) => `https://api.${systemName}.dev.assortment.leafio.app/`,
  loginUrl: (companyName: string) => `https://auth.${companyName}.dev.assortment.leafio.app/`,
  baseDomain: 'dev.shelf.leafio.app',
} as const;
